var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.298,
    height: 58.396,
    viewBox: "0 0 57.298 58.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_24",
    "data-name": "Intersection 24",
    d: "M27.28,58.4V42.345H19.887L12.134,57.937l-1.256-.624,13.4-26.957a5.041,5.041,0,0,1-1.333-2.55l-2.938.682L18.862,24.5,8.488,27.073l.429,1.509-6.34,2.072L0,21.576l6.339-2.071.378,1.33,10.322-2.67-.984-3.417,20.7-6.557L35.9,5.1,50.9,0l6.4,23.2v0L41.8,26.338,41.041,23.6,32.77,25.523a5,5,0,0,1-1.557,5.127L44.469,57.313l-1.256.624L35.46,42.345H28.682V58.4Zm1.4-26.567v9.113h6.08L30.029,31.42A5.034,5.034,0,0,1,28.682,31.829Zm-8.1,9.113h6.7V31.853a5.006,5.006,0,0,1-1.868-.621Zm3.582-14.1A3.737,3.737,0,1,0,27.9,23.111,3.741,3.741,0,0,0,24.166,26.847ZM1.607,22.431l1.86,6.551L7.31,27.727,5.45,21.176Zm16.063-6.818,3.257,11.315,1.947-.453a5.041,5.041,0,0,1,9.38-2.18l8.437-1.958L37.108,9.456ZM7.076,22.1,8.13,25.811,18.5,23.237l-1.1-3.811ZM37.492,5.941,42.739,24.81,55.66,22.193l-5.654-20.5Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScope);
export default __webpack_public_path__ + "static/media/scope.5ebc9ac9418e9d2d1ed685a97c8a42ef.svg";
export { ForwardRef as ReactComponent };